import React from "react";


import undraw_vector from "../../assets/celebration_re_kc9k 1.png";
import BZLogo from "../../components/BZLogo";
import { TwButton, TwMainLayout } from "../../components/tailwind";
import { OnBordingBaseLayout } from "../../components/onboarding/OnBordingBaseLayout";
import FitClubProLogoText from "../../components/FitClubProLogoText";

export default function BusinessProfileUpComplete({ navigation }) {

  return (
    <TwMainLayout fullScreen={true}>
      <OnBordingBaseLayout
        title={<FitClubProLogoText className={""} />}
        logoutCallBack={() => { }}
      >
        <div className="flex flex-col justify-center items-center p-5">
          <img
            className={"mt-5 md:mt-0 p-5 w-full md:w-9/12 [lg:w-6/12] lg:w-1/3 flex-1"}
            src={undraw_vector}
            alt={"vector"}
          />
          <h4
            className={
              "text-brown-coffee text-2xl sm:text-3xl font-bold my-4 sm:my-2 md:my-2 text-center"
            }
          >
            Congratulations,
            <br />
            Profile Completed!
          </h4>
          <p
            className={
              "text-brown-coffee text-center text-xl sm:text-lg my-4 sm:my-2 md:my-2"
            }
          >
            Let's continue to your Dashboard!
          </p>
          <TwButton
            className="w-full sm:w-auto sm:min-w-72 xs:text-base sm:text-xl"
            onClick={() => navigation("/home/dashboard")}
          >
            Continue
          </TwButton>
        </div>
      </OnBordingBaseLayout>
    </TwMainLayout>
  );
}
